import { AppColors } from "@/styles/colors";
import { Box } from "@chakra-ui/react";

const BADGE_STYLES: Record<string, { bg: string; color: string }> = {
  alquilado: { bg: AppColors.BROWN_TERRA, color: "white" },
  propio: { bg: AppColors.GREEN_PRIMARY, color: "white" },
};

const DEFAULT_BADGE_STYLE = { bg: AppColors.GRAY_BUTTON_BG, color: AppColors.GRAY_TEXT };

interface Props {
  tipo?: string;
}

export const TipoCampoBadge = ({ tipo }: Props) => {
  const styles = BADGE_STYLES[tipo?.toLowerCase() ?? ""] ?? DEFAULT_BADGE_STYLE;
  return (
    <Box
      px="8px"
      py="2px"
      borderRadius="4px"
      fontSize="12px"
      fontWeight={600}
      bg={styles.bg}
      color={styles.color}
      whiteSpace="nowrap"
    >
      {tipo || "Sin datos"}
    </Box>
  );
};
